<template>
  <footer class="row bg-secondary mx-0 my-1 text-white py-4">
    <div class="col-lg-4 mb-4">
      <h2 class="text-uppercase">Footer</h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi in
        harum vel id illum ut beatae, autem nisi! Odit reiciendis quisquam minus
        adipisci, mollitia quo quidem hic.
      </p>
      <p>Powered by <a href="#">w3.css</a></p>
    </div>
    <div class="col-lg-4 mb-4">
      <h2 class="text-uppercase">Blog Posts</h2>
      <ul class="ps-0 mx-0 ps-0">
        <li class="row mx-0 align-items-center list-unstyled">
          <img src="@/assets/images/workshop.jpg" class="col-3" alt="" />
          <div class="col-9">
            <h4 class="mb-0">Lorem, ipsum.</h4>
            <p class="mb-0">Lorem, ipsum dolor.</p>
          </div>
        </li>
        <hr class="bg-white" style="height: 2px; opacity: 1" />
        <li class="row mx-0 align-items-center list-unstyled">
          <img src="@/assets/images/gondol.jpg" class="col-3" alt="" />
          <div class="col-9">
            <h4 class="mb-0">Lorem, ipsum.</h4>
            <p class="mb-0">Lorem, ipsum dolor.</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-lg-4 mb-4">
      <h2 class="text-uppercase">Popular Tags</h2>
      <div>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Travel</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">New York</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">London</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">IKEA</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">NORWAY</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">DIY</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Ideas</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Baby</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Family</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">News</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Clothing</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Shpping</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Sports</a>
        <a href="#" class="btn btn-light btn-sm my-3 mx-1">Games</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style>
</style>
